import { CSSProperties } from 'react';

interface PropsType {
  style?: CSSProperties;
  color?: string;
}

const SvgIconEvent = (props: PropsType) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style ? props.style : undefined}
    >
      <g mask='url(#mask0_1235_3833)'>
        <path
          d='M3.22222 7.1V6H8.77778V7.1H3.22222ZM3.22222 9.3V8.2H7.11111V9.3H3.22222ZM2.11111 11.5C1.80556 11.5 1.54398 11.3923 1.32639 11.1769C1.1088 10.9615 1 10.7025 1 10.4V2.7C1 2.3975 1.1088 2.13854 1.32639 1.92312C1.54398 1.70771 1.80556 1.6 2.11111 1.6H2.66667V0.5H3.77778V1.6H8.22222V0.5H9.33333V1.6H9.88889C10.1944 1.6 10.456 1.70771 10.6736 1.92312C10.8912 2.13854 11 2.3975 11 2.7V10.4C11 10.7025 10.8912 10.9615 10.6736 11.1769C10.456 11.3923 10.1944 11.5 9.88889 11.5H2.11111ZM2.11111 10.4H9.88889V4.9H2.11111V10.4Z'
          fill={props.color ? props.color : '#E4E4E4'}
        />
      </g>
    </svg>
  );
};

export default SvgIconEvent;
